




































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import PageFooter from '@/pdf/components/PageFooter.vue';
import DynamicLineChart from '@/charts/DynamicLineChart.vue';
import DynamicColumnChart from '@/charts/DynamicColumnChart.vue';
import CompanyMixin from '@/mixins/CompanyMixin';

@Component ({
  components: { PageFooter, DynamicColumnChart, DynamicLineChart },
})
export default class CompanyCashflowExtended extends CompanyMixin {
  @Prop() readonly doc!: any;

  get loaded() {
    return this.cashflow && this.balance;
  }

}
